import React from 'react';

type Props = {
  color?: string,
  onClick?: () => void,
} & typeof defaultProps;

const defaultProps = {
  color: '#7E7E7E',
  onClick: () => { },
};

const DownloadIcon = function DownloadIcon(props: Props) {
  const { color, onClick } = props;
  return (
    <svg width="40" height="45" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg" className="regenerate-icon-svg" onClick={onClick}>
      <path fillRule="evenodd" clipRule="evenodd" d="M0 41.6928C0 40.22 1.35159 39.0261 3.01887 39.0261H36.9811C38.6484 39.0261 40 40.22 40 41.6928C40 43.1655 38.6484 44.3595 36.9811 44.3595H3.01887C1.35159 44.3595 0 43.1655 0 41.6928Z" fill={color} />
      <path d="M22.1847 33.8261C21.7176 34.3502 21.0241 34.6823 20.2499 34.6823C19.4757 34.6823 18.7822 34.3502 18.3151 33.8261L11.2457 27.0302C10.2512 26.0741 10.2512 24.524 11.2457 23.5679C12.2403 22.6118 13.8528 22.6118 14.8474 23.5679L17.7031 26.3132L17.7031 2.8553C17.7031 1.50318 18.8434 0.407069 20.2499 0.40707C21.6564 0.40707 22.7967 1.50318 22.7967 2.8553L22.7967 26.3132L25.6524 23.5679C26.647 22.6118 28.2595 22.6118 29.2541 23.5679C30.2486 24.524 30.2486 26.0741 29.2541 27.0302L22.1847 33.8261Z" fill={color} />
    </svg>
  );
};
DownloadIcon.defaultProps = defaultProps;
export default DownloadIcon;
